import React from 'react'
import { connect } from 'react-redux'
import AdviserDataDump from './AdviserDataDump'
import { downloadCurrentData } from './adviserDataDumpContainerActions'
import PropTypes from 'prop-types';

class AdviserDataDumpContainer extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    downloadCurrentData: PropTypes.func.isRequired,
    downloading: PropTypes.bool.isRequired,
    downloaded: PropTypes.bool.isRequired
  }

  render () {
    return (
      <div>
        <AdviserDataDump
          downloading={this.props.downloading}
          downloaded={this.props.downloaded}
          downloadCurrentData={() => this.props.dispatch(this.props.downloadCurrentData())}
      />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    downloading: state.adviserDataDumpContainer.downloading,
    downloaded: state.adviserDataDumpContainer.downloaded
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: dispatch,
    downloadCurrentData: downloadCurrentData
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdviserDataDumpContainer)
